(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["thicket-product-promise"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('delivery-estimate')) {
    customElements.define(
      'delivery-estimate',
      class DeliveryEstimate extends HTMLElement {
        connectedCallback() {
          const min = parseInt(this.dataset.min, 10);
          const max = parseInt(this.dataset.max, 10);
          if (!(min > 0) || !(max > 0)) return;

          const holidays = new Set(
            (this.dataset.holidays || '')
              .split(',')
              .map((s) => s.trim())
              .filter(Boolean)
          );
          const iso = (d) => d.toISOString().slice(0, 10);
          const isWorkingDay = (d) => d.getUTCDay() % 6 !== 0 && !holidays.has(iso(d));
          const addWorkingDays = (from, n) => {
            const d = new Date(from);
            let added = 0;
            while (added < n) {
              d.setUTCDate(d.getUTCDate() + 1);
              if (isWorkingDay(d)) added++;
            }
            return d;
          };

          // Today's date in the UK, held as UTC midnight so day maths ignores time zones
          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/London',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
          }).formatToParts(new Date());
          const part = (type) => parts.find((p) => p.type === type).value;
          const today = new Date(`${part('year')}-${part('month')}-${part('day')}T00:00:00Z`);

          const weekday = (d) => d.toLocaleDateString('en-GB', { weekday: 'short', timeZone: 'UTC' });
          const dayMonth = (d) => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
          const full = (d) => `${weekday(d)} ${dayMonth(d)}`;

          const earliest = addWorkingDays(today, min);
          const latest = addWorkingDays(today, max);
          let range;
          if (min === max) {
            range = full(latest);
          } else if (earliest.getUTCMonth() === latest.getUTCMonth()) {
            range = `${weekday(earliest)} ${earliest.getUTCDate()} – ${full(latest)}`;
          } else {
            range = `${full(earliest)} – ${full(latest)}`;
          }

          const eta = this.querySelector('[data-eta]');
          eta.textContent = 'Estimated arrival: ';
          const strong = document.createElement('strong');
          strong.textContent = range;
          eta.append(strong);

          // Christmas: the last day to order so this item arrives by Christmas Eve, capped at the store-wide cut-off
          const cutoffSetting = this.dataset.christmasCutoff;
          if (!/^\d{4}-\d{2}-\d{2}$/.test(cutoffSetting || '')) return;
          const cutoff = new Date(`${cutoffSetting}T00:00:00Z`);
          const seasonStart = new Date(Date.UTC(cutoff.getUTCFullYear(), 9, 1));
          const deliverBy = new Date(Date.UTC(cutoff.getUTCFullYear(), 11, 24));

          let lastOrderDay = new Date(cutoff);
          while (addWorkingDays(lastOrderDay, max) > deliverBy) {
            lastOrderDay.setUTCDate(lastOrderDay.getUTCDate() - 1);
          }

          if (today >= seasonStart && today <= lastOrderDay) {
            const xmas = this.querySelector('[data-christmas]');
            const longDate = lastOrderDay.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', timeZone: 'UTC' });
            xmas.textContent = `Order by ${longDate} for Christmas.`;
            xmas.hidden = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
